"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var to_array_pipe_1 = require("./to-array.pipe");
var message_pipe_1 = require("./message.pipe");
var name_pipe_1 = require("./name.pipe");
var report_element_name_pipe_1 = require("./report-element-name.pipe");
var report_element_measure_path_pipe_1 = require("./report-element-measure-path.pipe");
var report_element_path_pipe_1 = require("./report-element-path.pipe");
var path_name_pipe_1 = require("./path-name.pipe");
var path_class_name_pipe_1 = require("./path-class-name.pipe");
var path_type_name_pipe_1 = require("./path-type-name.pipe");
var filter_paths_pipe_1 = require("../sis-tabular-report-designer/sis-tabular-report-table-header/pipe/filter-paths.pipe");
var exclude_same_path_in_branch_pipe_1 = require("../sis-tabular-report-designer/sis-tabular-report-rows-panel/pipe/exclude-same-path-in-branch.pipe");
var report_element_reference_number_pipe_1 = require("./report-element-reference-number.pipe");
var message_placeholder_replacer_pipe_1 = require("./message-placeholder-replacer.pipe");
var text_style_to_font_style_pipe_1 = require("../sis-tabular-report-options/pipe/text-style-to-font-style.pipe");
var reference_name_pipe_1 = require("./reference-name.pipe");
var dataset_name_pipe_1 = require("./dataset-name.pipe");
var sanitize_pipe_1 = require("./sanitize.pipe");
var csv_delimiter_pipe_1 = require("./csv-delimiter.pipe");
var defined_message_pipe_1 = require("./defined-message.pipe");
var ReportingPipesModule = /** @class */ (function () {
    function ReportingPipesModule() {
    }
    ReportingPipesModule = __decorate([
        core_1.NgModule({
            declarations: [
                to_array_pipe_1.ToArrayPipe,
                message_pipe_1.MessagePipe,
                name_pipe_1.NamePipe,
                reference_name_pipe_1.ReferenceNamePipe,
                dataset_name_pipe_1.DatasetNamePipe,
                report_element_name_pipe_1.ReportElementNamePipe,
                report_element_measure_path_pipe_1.ReportElementMeasurePathPipe,
                report_element_path_pipe_1.ReportElementPathPipe,
                report_element_reference_number_pipe_1.ReportElementReferenceNumberPipe,
                path_name_pipe_1.PathNamePipe,
                path_class_name_pipe_1.PathClassNamePipe,
                path_type_name_pipe_1.PathTypeNamePipe,
                filter_paths_pipe_1.FilterPathsPipe,
                exclude_same_path_in_branch_pipe_1.ExcludeSamePathInBranchPipe,
                message_placeholder_replacer_pipe_1.MessagePlaceholderReplacerPipe,
                text_style_to_font_style_pipe_1.TextStyleToFontStylePipe,
                sanitize_pipe_1.SanitizePipe,
                csv_delimiter_pipe_1.CSVDelimiterPipe,
                defined_message_pipe_1.DefinedMessagePipe
            ],
            exports: [
                to_array_pipe_1.ToArrayPipe,
                message_pipe_1.MessagePipe,
                name_pipe_1.NamePipe,
                report_element_name_pipe_1.ReportElementNamePipe,
                report_element_measure_path_pipe_1.ReportElementMeasurePathPipe,
                report_element_path_pipe_1.ReportElementPathPipe,
                report_element_reference_number_pipe_1.ReportElementReferenceNumberPipe,
                path_name_pipe_1.PathNamePipe,
                path_class_name_pipe_1.PathClassNamePipe,
                path_type_name_pipe_1.PathTypeNamePipe,
                filter_paths_pipe_1.FilterPathsPipe,
                exclude_same_path_in_branch_pipe_1.ExcludeSamePathInBranchPipe,
                message_placeholder_replacer_pipe_1.MessagePlaceholderReplacerPipe,
                text_style_to_font_style_pipe_1.TextStyleToFontStylePipe,
                reference_name_pipe_1.ReferenceNamePipe,
                dataset_name_pipe_1.DatasetNamePipe,
                sanitize_pipe_1.SanitizePipe,
                csv_delimiter_pipe_1.CSVDelimiterPipe,
                defined_message_pipe_1.DefinedMessagePipe
            ]
        })
    ], ReportingPipesModule);
    return ReportingPipesModule;
}());
exports.ReportingPipesModule = ReportingPipesModule;
//# sourceMappingURL=reporting-pipes.module.js.map